import { createSelector } from 'reselect'

const getOndemandViewer = (state: any) => state.audienceOndemandViewers

/** A Redux selector to retrieve Ondemand viewer Data
 * @param state - The Redux state
 * @param {object} - Live viewer Data.
 */

export const selectOndemandViewers = createSelector(
  getOndemandViewer,
  (data) => data && data.audienceOndemandViewersData ? data.audienceOndemandViewersData : null
)
